import React from 'react'

import CoursesOverview from '/react4xp/components/pages/courses-overview'

function CoursesOverviewFSLayout(props: any) {
    return (
        <CoursesOverview {...props} />
    )
}

export default (props) => <CoursesOverviewFSLayout {...props} />
